export const AUSTRALIA_AREA_HA = 768828700;
